import { isMobileWebView } from './mobileWebView'

const splitUrl: (url: string) => {
  path: string
  searchParams: URLSearchParams
} = (uri: string) => {
  // Get everything after the `?`
  const [path, paramString] = uri.split('?')

  // Return parametersOs
  return { path: path, searchParams: new URLSearchParams(paramString) }
}

export const preserveSearchParams = (to: string, search: string = window.location.search): string => {
  const { path, searchParams } = splitUrl(to)

  const currentSearchParams = new URLSearchParams(search)
  const parametersToKeep = ['isMobileView']
  for (const param of parametersToKeep) {
    if (currentSearchParams.has(param)) {
      searchParams.set(param, currentSearchParams.get(param) as string)
    }
  }
  const finalSearchParams = searchParams.toString() ? `?${searchParams.toString()}` : ''
  return `${path}${finalSearchParams}`
}

export const isWebView = (search: string = window.location.search) => {
  return isMobileWebView(new URLSearchParams(search))
}
